angular.module('clients')
    .component('dashboardClientSearch', {
        templateUrl: 'app/clients/client-dashboard-search/dashboard-client-search.html',
        controller: function (Client, ClientService){
            this.$onInit = () => {
                this.clientSearchText = ""
                this.foundClients = []
            }

            this.clientSearch = () => {
                if (this.clientSearchText === "") {
                    this.foundClients = []
                    return
                }
                return Client.autocomplete({q: this.clientSearchText, searchDetails: true}).$promise
                    .then(response => this.foundClients = response)
            }

            this.addClientModal = () => ClientService.addModal().then(client => ClientService.show(client.id))
        }
    })
